import { redo as redo_1 } from './redo.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import { isMac } from 'owa-user-agent/lib/userAgent';

const redo: RibbonButton = {
    key: 'redo',
    title: () => loc(redo_1),
    imageSrc: require('../svg/redo.svg'),
    shortcut: isMac() ? 'command+shift+z' : 'ctrl+y',
    buttonState: formatState =>
        formatState.canRedo ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: plugin => plugin.getEditor().redo(),
};

export default redo;
